import React from 'react'

function HomeBlog(props) {
  return (
    <div className='BlogContainer'>
        {/* <h1>Blog</h1>
        <p> hi it me</p> */}
    </div>
  )
}

export default HomeBlog